// extracted by mini-css-extract-plugin
export var icon = "_7x-1";
export var subtext = "_7x-0";